export default __webpack_public_path__ + "static/media/frg--castle-hill.f41f3bf8.png";